import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import { Box, Typography, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { headerStyles } from '../../styles/drawerStyles';

/**
 * 히스토리 드로어 헤더 컴포넌트
 * @param {object} props - 컴포넌트 props
 * @param {function} props.onGoHome - 홈으로 이동 핸들러
 * @returns {JSX.Element} - 드로어 헤더
 */
const DrawerHeader = ({ onGoHome }) => {
  const { t } = useTranslation();

  return (
    <Box onClick={onGoHome} sx={headerStyles.container}>
      <HomeIcon sx={headerStyles.icon} />
      <Typography sx={headerStyles.title}>
        {t('drawer.analysisHome')}
      </Typography>
    </Box>
  );
};

export default DrawerHeader; 